<template>
  <section class="dp-layout agreement-coin-ranking">
    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>
    <section class="dp-right">
      <div class="toolbar-filter-bar">
        <el-form :inline="true" class="toolbar-filter-form">
          <div class="toolbar-filter-fields">
            <el-form-item label="排行类型">
              <el-select v-model="filters.rankingType" class="toolbar-field-w-md">
                <el-option label="按分值" :value="1"></el-option>
                <el-option label="按次数" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="类型">
              <el-select v-model="filters.coinTypeId" clearable placeholder="全部" class="toolbar-field-w-md">
                <el-option v-for="t in typeOptions" :key="t.Id" :label="t.Name" :value="t.Id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间范围">
              <el-date-picker
                v-model="filters.dateRange"
                type="daterange"
                start-placeholder="开始"
                end-placeholder="结束"
                value-format="yyyy-MM-dd"
                class="toolbar-field-w-daterange"
                clearable
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" icon="el-icon-search" @click="query">查询</el-button>
            </el-form-item>
          </div>
          <div class="toolbar-filter-actions">
            <el-button size="small" type="info" icon="el-icon-refresh-left" @click="reset">重置</el-button>
            <el-button size="small" type="warning" icon="el-icon-download" :loading="exporting" @click="exportExcel">导出</el-button>
          </div>
        </el-form>
      </div>

      <div class="tbl-scroll-host">
      <el-table :data="list" v-loading="loading" border style="width: 100%;" height="100%">
        <el-table-column prop="Rank" label="排名" width="80" align="center"></el-table-column>
        <el-table-column prop="StudentName" label="学生" min-width="120" align="center"></el-table-column>
        <el-table-column prop="DepartmentName" label="班级" min-width="140" align="center"></el-table-column>
        <el-table-column prop="TotalScore" label="协约币分" width="120" align="center">
          <template slot-scope="scope">
            <el-button type="text" class="ac-link-num" @click="openDetail(scope.row)">{{ scope.row.TotalScore }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="TotalCount" label="获得次数" width="120" align="center">
          <template slot-scope="scope">
            <el-button type="text" class="ac-link-num" @click="openDetail(scope.row)">{{ scope.row.TotalCount }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <div class="pagination-container">
        <el-pagination
          layout="total, sizes, prev, pager, next"
          :total="pagination.total"
          :current-page.sync="pagination.page"
          :page-size.sync="pagination.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          @current-change="loadData"
          @size-change="handleSizeChange"
        ></el-pagination>
      </div>

      <el-dialog 
        :title="detailTitle"
        :visible.sync="detailVisible"
        width="900px"
        top="8vh"
        append-to-body
        :close-on-click-modal="false"
      >
        <el-table :data="detailList" v-loading="detailLoading" border size="small" max-height="420">
          <el-table-column prop="CreateTime" label="时间" min-width="150" align="center">
            <template slot-scope="scope">{{ formatTime(scope.row.CreateTime) }}</template>
          </el-table-column>
          <el-table-column prop="CoinTypeName" label="类型" min-width="100" align="center"></el-table-column>
          <el-table-column prop="FaceValue" label="面值" width="70" align="center"></el-table-column>
          <el-table-column prop="Score" label="币分" width="70" align="center"></el-table-column>
          <el-table-column prop="EvaluationItemName" label="评价项" min-width="120" align="center"></el-table-column>
          <el-table-column prop="OperatorName" label="操作人" min-width="90" align="center"></el-table-column>
          <el-table-column label="来源" width="90" align="center">
            <template slot-scope="scope">{{ formatSource(scope.row.Source) }}</template>
          </el-table-column>
        </el-table>
        <div class="pagination-container" style="margin-top: 10px;">
          <el-pagination
            layout="total, prev, pager, next"
            :total="detailPagination.total"
            :current-page.sync="detailPagination.page"
            :page-size="detailPagination.pageSize"
            @current-change="loadDetailRecords"
          ></el-pagination>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import DepartmentPane from '../../components/DepartmentPane';
import {
  getAgreementCoinRanking,
  getAgreementCoinTypes,
  getAgreementCoinRecords,
  exportAgreementCoinRanking
} from '../../api/modules/agreement-coin';
import { resolveActiveSchoolId, treeNodeDeptId } from '../../utils/deptCascaderProps';

const SOURCE_LABEL = {
  Cplate: '班牌',
  TeacherApi: '教师补录',
  WebAdmin: 'Web后台'
};

export default {
  name: 'AgreementCoinRanking',
  components: { DepartmentPane },
  data() {
    return {
      loading: false,
      exporting: false,
      schoolDepartmentId: null,
      departmentId: null,
      typeOptions: [],
      filters: {
        rankingType: 1,
        coinTypeId: null,
        dateRange: []
      },
      list: [],
      pagination: { page: 1, pageSize: 10, total: 0 },
      detailVisible: false,
      detailLoading: false,
      detailStudent: null,
      detailList: [],
      detailPagination: { page: 1, pageSize: 10, total: 0 }
    };
  },
  computed: {
    detailTitle() {
      const name = (this.detailStudent && this.detailStudent.StudentName) || '';
      const cls = (this.detailStudent && this.detailStudent.DepartmentName) || '';
      if (!name) return '获得明细';
      return cls ? `获得明细 · ${name}（${cls}）` : `获得明细 · ${name}`;
    }
  },
  methods: {
    formatTime(v) {
      if (!v) return '';
      return String(v).replace('T', ' ').substring(0, 19);
    },
    formatSource(source) {
      if (!source) return '—';
      return SOURCE_LABEL[source] || source;
    },
    treeNodeClick(data) {
      const deptId = treeNodeDeptId(data);
      if (!deptId) return;
      const orgType = String((data && (data.DeptOrgType || data.deptOrgType)) || '').toLowerCase();
      // 点哪个节点就按哪个部门范围查（学校/年级/班级都会展开到班级学生）
      this.departmentId = deptId;
      if (orgType === 'school' || orgType === 'affiliateschool') {
        this.schoolDepartmentId = deptId;
      } else {
        this.schoolDepartmentId = resolveActiveSchoolId(this) || deptId;
      }
      this.loadTypes();
      this.query();
    },
    loadTypes() {
      const schoolId = this.schoolDepartmentId;
      if (!schoolId) {
        this.typeOptions = [];
        return;
      }
      getAgreementCoinTypes({
        schId: String(schoolId),
        schoolDepartmentId: schoolId,
        enabledOnly: true
      }).then(res => {
        if (res.data && res.data.success) this.typeOptions = res.data.response || [];
      });
    },
    query() {
      this.pagination.page = 1;
      this.loadData();
    },
    reset() {
      this.filters.rankingType = 1;
      this.filters.coinTypeId = null;
      this.filters.dateRange = [];
      this.query();
    },
    handleSizeChange() {
      this.pagination.page = 1;
      this.loadData();
    },
    /** 构建当前筛选参数（查询、导出共用） */
    buildFilterParams() {
      const params = {
        schId: this.schoolDepartmentId ? String(this.schoolDepartmentId) : undefined,
        schoolDepartmentId: this.schoolDepartmentId || undefined,
        departmentId: this.departmentId || undefined,
        coinTypeId: this.filters.coinTypeId || undefined,
        rankingType: this.filters.rankingType || 1
      };
      if (this.filters.dateRange && this.filters.dateRange.length === 2) {
        params.startTime = this.filters.dateRange[0];
        params.endTime = this.filters.dateRange[1];
      }
      return params;
    },
    loadData() {
      this.loading = true;
      const params = Object.assign({}, this.buildFilterParams(), {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize
      });
      getAgreementCoinRanking(params).then(res => {
        this.loading = false;
        if (res.data && res.data.success) {
          const page = res.data.response || {};
          this.list = page.data || [];
          this.pagination.total = page.dataCount || 0;
        } else {
          this.$message.error((res.data && res.data.msg) || '查询失败');
        }
      }).catch(() => { this.loading = false; });
    },
    /** 打开学生获得明细弹窗。创建于 2026-07-28 */
    openDetail(row) {
      if (!row || !row.StudentId) {
        this.$message.warning('学生信息无效');
        return;
      }
      this.detailStudent = row;
      this.detailPagination.page = 1;
      this.detailVisible = true;
      this.loadDetailRecords();
    },
    loadDetailRecords() {
      if (!this.detailStudent || !this.detailStudent.StudentId) return;
      this.detailLoading = true;
      const params = {
        schId: this.schoolDepartmentId ? String(this.schoolDepartmentId) : undefined,
        schoolDepartmentId: this.schoolDepartmentId || undefined,
        studentId: this.detailStudent.StudentId,
        coinTypeId: this.filters.coinTypeId || undefined,
        page: this.detailPagination.page,
        pageSize: this.detailPagination.pageSize
      };
      if (this.filters.dateRange && this.filters.dateRange.length === 2) {
        params.startTime = this.filters.dateRange[0];
        params.endTime = this.filters.dateRange[1];
      }
      getAgreementCoinRecords(params).then(res => {
        this.detailLoading = false;
        if (res.data && res.data.success) {
          const page = res.data.response || {};
          this.detailList = page.data || [];
          this.detailPagination.total = page.dataCount || 0;
        } else {
          this.$message.error((res.data && res.data.msg) || '加载明细失败');
        }
      }).catch(() => { this.detailLoading = false; });
    },
    /** 按当前筛选条件调用后端接口导出 Excel。创建于 2026-07-25 */
    async exportExcel() {
      try {
        const response = await exportAgreementCoinRanking(this.buildFilterParams());
        const blob = response && response.data;
        if (!blob) {
          this.$message.error('导出数据为空');
          return;
        }
        if (blob.type && blob.type.indexOf('application/json') >= 0) {
          const text = await blob.text();
          let msg = '导出失败';
          try {
            const json = JSON.parse(text);
            msg = json.msg || json.message || msg;
          } catch (e) { /* ignore */ }
          this.$message.error(msg);
          return;
        }
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `协约币排行_${this.buildExportDateSuffix()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        let msg = '导出失败，请稍后重试';
        try {
          const errBlob = error && error.response && error.response.data;
          if (errBlob && typeof errBlob.text === 'function') {
            const text = await errBlob.text();
            if (text) {
              try {
                const json = JSON.parse(text);
                msg = json.msg || json.message || text;
              } catch (e) {
                msg = text;
              }
            }
          }
        } catch (e) { /* ignore */ }
        this.$message.error(msg);
      }
    },
    /** 导出文件名日期后缀 */
    buildExportDateSuffix() {
      if (this.filters.dateRange && this.filters.dateRange.length === 2) {
        return this.filters.dateRange.map(x => String(x).replace(/-/g, '')).join('_');
      }
      return '全部';
    }
  }
};
</script>

<style scoped>
/* 左右栏宽度/卡片样式走全局 split-layout.css（.dp-left = 250px） */
.toolbar { margin-bottom: 8px; }
.ac-link-num {
  padding: 0;
  font-weight: 600;
}
</style>
